export default __webpack_public_path__ + "static/media/PersonCar.a0dad020.svg";